import { observer } from 'mobx-react'
import React, { Dispatch, FC, SetStateAction, useState } from 'react'
import { FormikProvider, useFormik } from 'formik'
import TextareaAutosize from 'react-textarea-autosize'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import PropTypes from 'prop-types'
import { toast } from 'react-toastify'

import styles from '../brief-styles.module.scss'
import BtnBasic from '../../../../../utils/components/Button/BtnBasic'
import briefR from '../../../../../mobx/brief'
import  userMobx  from '../../../../../mobx/user'
import { ClientI } from '../../../../../types-project/Client'

interface CardTipsProps {
    setModalTips: Dispatch<SetStateAction<boolean>>,
    idBa: string,
    briefApplications?: Array<{ _id: string, name?: string }>,
}
const CardTips: FC<CardTipsProps> = ({setModalTips, idBa, briefApplications}) => {
    const { t } = useTranslation()
    type Tips = {
        amount: number | undefined
        description: string
      }
    const userInfos =userMobx.getUserInfos() as ClientI
    // Le createur peut avoir plusieurs collabs avec la marque : on choisit
    // celle qui portera la transaction, sans sortir de la modale.
    const [selectedBa, setSelectedBa] = useState(idBa)
    const handleSendTips = () => {
        if (!selectedBa) {
            toast.error('Impossible d envoyer le tips : candidat introuvable')
            return
        }
        briefR.sendTips(
          selectedBa,
          formikTips.values.amount!,
          formikTips.values.description,
          (tips) => {
            setModalTips(false)
            toast.success(`Tips de ${tips}€ à été envoyé avec succès`)
          }
        )
    }

    const validationSchemaTips = Yup.object().shape({
        amount: Yup.number().required('Merci de renseigner le montant'),
      })
    const onSuccess = (stripeUrl: string) => {
      window.location.href = stripeUrl
    }
    const formikTips = useFormik<Tips>({
        initialValues: { amount: undefined, description: '' },
        validateOnChange: true,
        validateOnBlur: true,
        validateOnMount: true,
        validationSchema: validationSchemaTips,
        onSubmit: () => {
          if (userInfos._company.credits < formikTips.values.amount!){
            // Hors page campagne (messagerie, profil createur) il n'y a pas de
            // brief en store : on revient sur l'ecran courant apres Stripe.
            const back = briefR.brief.data?._id
              ? `/dashboard/castings/${briefR.brief.data._id}`
              : `${window.location.pathname}${window.location.search}`
            userMobx.getTopUpLink(formikTips.values.amount! - userInfos._company.credits, {
              ok: `${back}${back.includes('?') ? '&' : '?'}card=ok`,
              ko: `${back}${back.includes('?') ? '&' : '?'}card=ko`,
            }, onSuccess, () => {})
          } else
            handleSendTips()
        },
      })
  return (
    <div className={styles['tips-modal']}>
      <button type="button" className={styles['close']} onClick={() => setModalTips(false)}>
        <i className="fa-solid fa-xmark" />
      </button>
      <div className={styles['head']}>
        <span className={styles['icon-badge']}>
          <i className="fa-solid fa-hand-holding-dollar" />
        </span>
        <h1>{t('mycastings:private-deal:tips-title')}</h1>
        <p>{t('mycastings:private-deal:tips-desc')}</p>
      </div>
      <FormikProvider value={formikTips}>
        <form onSubmit={formikTips.handleSubmit} className={styles['body']}>
          {briefApplications && briefApplications.length > 1 && (
            <>
              <label className={styles['label']} htmlFor="brief-application">
                {t('mycastings:private-deal:tips-campaign', 'Campagne concernée')}
              </label>
              <select
                id="brief-application"
                className={styles['ba-field']}
                value={selectedBa}
                onChange={(ev) => setSelectedBa(ev.target.value)}
              >
                {briefApplications.map((ba) => (
                  <option key={ba._id} value={ba._id}>{ba.name ?? ba._id}</option>
                ))}
              </select>
            </>
          )}
          <label
            className={styles['label']}
            htmlFor="description"
            dangerouslySetInnerHTML={{ __html: t('mycastings:private-deal:tips-comment') }}
          />
          <TextareaAutosize
            id="description"
            minRows={3}
            maxRows={5}
            className={styles['text-field']}
            onChange={formikTips.handleChange}
            value={formikTips.values.description}
            name="description"
            placeholder={t('mycastings:private-deal:tips-placeholder')}
          />
          <div className={styles['amount-row']}>
            <div className={styles['amount-field']}>
              <input
                required
                type="number"
                min={1}
                onChange={formikTips.handleChange}
                value={formikTips.values.amount ?? ''}
                name="amount"
                id="amount"
                placeholder={t('mycastings:private-deal:tips-placeholder-amount')}
              />
            </div>
            <BtnBasic
              disabled={!formikTips.isValid}
              type="inverted-sky-violet"
              btnName={t('mycastings:private-deal:send')}
              typeBtn="submit"
            />
          </div>
        </form>
      </FormikProvider>
    </div>
  )
}

CardTips.defaultProps = {
    briefApplications: undefined,
}

CardTips.propTypes = {
    setModalTips: PropTypes.func.isRequired,
    idBa: PropTypes.string.isRequired,
    briefApplications: PropTypes.any,
}

export default observer(CardTips)
